/*
  Compra rapida con el modelo ya elegido.

  En las colecciones que llevan el metacampo custom.modelo_preseleccionado, la
  tarjeta pinta <quick-buy data-cork-preselect="Opcion1|Opcion2">. Al abrirla se
  marcan esas opciones y se lanza un solo 'change', que es lo que el tema ya usa
  para cargar la variante. No se hace al cargar la pagina para no pedir una
  seccion por cada tarjeta.
*/
(() => {
  const HECHO = 'corkPreseleccionHecha';

  const preselecciona = (compra) => {
    if (!compra || compra.dataset[HECHO] === '1') return;
    const valores = (compra.dataset.corkPreselect || '').split('|').map((v) => v.trim()).filter(Boolean);
    if (!valores.length) return;
    compra.dataset[HECHO] = '1';

    const picker = compra.querySelector('product-variants');
    if (!picker) return;

    let ultimo = null;
    valores.forEach((valor) => {
      const select = [...picker.querySelectorAll('select')].find((s) => [...s.options].some((o) => o.value === valor));
      if (select) {
        if (select.value !== valor) select.value = valor;
        ultimo = select;
        return;
      }
      const radio = [...picker.querySelectorAll('input.product-variant__input')].find((r) => r.value === valor);
      if (radio) {
        radio.checked = true;
        ultimo = radio;
      }
    });
    // un solo change: el tema lee todas las opciones marcadas de una vez
    if (ultimo) ultimo.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const enLaTarjeta = (nodo) => {
    const tarjeta = nodo.closest('[data-js-product-item]');
    return tarjeta ? tarjeta.querySelector('quick-buy[data-cork-preselect]') : null;
  };

  document.addEventListener('click', (evento) => {
    const abre = evento.target.closest('[data-js-product-open-popup], .product-item__quick-buy');
    if (abre) { preselecciona(enLaTarjeta(abre)); return; }
    const dentro = evento.target.closest('quick-buy[data-cork-preselect]');
    if (dentro) preselecciona(dentro);
  }, true);

  // por si la compra rapida se muestra al pasar el raton, sin clic
  document.addEventListener('pointerenter', (evento) => {
    const t = evento.target;
    if (t && t.nodeType === 1 && t.matches && t.matches('[data-js-product-item]')) {
      const compra = t.querySelector('quick-buy[data-cork-preselect]');
      if (compra) preselecciona(compra);
    }
  }, true);
})();
